'use client';

import type { Table } from '@tanstack/react-table';
import { Download } from 'lucide-react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import {
    DataTableActionBar,
    DataTableActionBarAction,
    DataTableActionBarSelection,
} from '@/components/data-table/data-table-action-bar';
import { Separator } from '@/components/ui/separator';
import { Customer } from '@/lib/api/customers';

interface CustomersTableActionBarProps {
    table: Table<Customer>;
    onExport?: () => void;
}

export function CustomersTableActionBar({ table, onExport }: CustomersTableActionBarProps) {
    const { t } = useTranslation(['customers']);
    const rows = table.getFilteredSelectedRowModel().rows;

    const handleExport = React.useCallback(() => {
        if (onExport) {
            onExport();
        }
    }, [onExport]);

    return (
        <DataTableActionBar table={table} visible={rows.length > 0}>
            <DataTableActionBarSelection table={table} />
            {onExport && (
                <>
                    <Separator
                        orientation="vertical"
                        className="hidden data-[orientation=vertical]:h-5 sm:block"
                    />
                    <div className="flex items-center gap-1.5">
                        <DataTableActionBarAction
                            tooltip={t('customers:exportDialog.title')}
                            onClick={handleExport}
                        >
                            <Download className="mr-2 h-4 w-4" />
                            {t('customers:export')}
                        </DataTableActionBarAction>
                    </div>
                </>
            )}
        </DataTableActionBar>
    );
}
